const AttributeType = { ALL: '0', NON_GLOBAL_ATTRIBUTES: '1', GLOBAL_ATTRIBUTES: '2' };

export { AttributeType };
